import { Button, Icon } from '@deepdive-ui';
import { useAppDispatch } from '@/store/hooks';
import { openDialog } from '@/store/slices/uiSlice';
import styles from './reports.module.css';

export function ReportActionsDock() {
  const dispatch = useAppDispatch();
  return (
    <div className={styles.actions} aria-label="Report actions">
      <Button
        hierarchy="primary"
        iconLeading={<Icon name="add" />}
        onClick={() => dispatch(openDialog('add-widget'))}
      >
        Add widget
      </Button>
      <Button hierarchy="secondary" onClick={() => dispatch(openDialog('campaign'))}>
        Configure campaign
      </Button>
      <Button
        hierarchy="tertiary"
        iconLeading={<Icon name="share" />}
        onClick={() => dispatch(openDialog('share-report'))}
      >
        Share
      </Button>
    </div>
  );
}
